const { default: Styled, css } = require('styled-components');
const T = require('prop-types');

const { default: FormControl } = require('@mui/material/FormControl');
const { default: Select } = require('@mui/material/Select');
const { default: MenuItem } = require('@mui/material/MenuItem');
const { default: ListItemText } = require('@mui/material/ListItemText');

const SelectInputLabel = require('components/SelectInputLabel');
const ControlledSelectField = require('hooks/useFormPrimitives/ControlledSelectField');

const internals = {};

module.exports = function RoleGroupFilter(props) {

    const {
        disableUnderline,
        fieldStyles,
        selectVariant,
        setRoleGroupFilter,
        availableRoleGroups,
        onChange
    } = props;

    let { roleGroupFilter } = props;

    const {
        EmptySelectIcon,
        StyledFormControl
    } = internals;

    if (!availableRoleGroups?.length) {
        return null;
    }

    const handleValueChange = (value) => {

        let val = value;
        val = val?.filter || val;

        setRoleGroupFilter(val);

        if (onChange) {
            onChange(val);
        }
    };

    const handleChange = (event) => {

        handleValueChange(event.target.value);
    };

    const isSingleRoleGroup = availableRoleGroups.length === 1;
    const matchingRoleGroup = availableRoleGroups.find(({ name }) => name === roleGroupFilter);

    if (isSingleRoleGroup) {
        roleGroupFilter = availableRoleGroups[0].name;
    }
    else if (!matchingRoleGroup) {
        roleGroupFilter = 'all';
    }

    const roleOptions = isSingleRoleGroup ? availableRoleGroups : [
        {
            id: 'all',
            name: 'all',
            label: 'All'
        },
        ...availableRoleGroups
    ];
    const selectProps = isSingleRoleGroup ? {
        IconComponent: EmptySelectIcon,
        sx: internals.singleRoleSelectSx
    } : {};

    if (selectVariant === 'filled') {
        return <ControlledSelectField
            label='Role'
            value={roleGroupFilter}
            options={roleOptions.map(({ name, label }) => ({
                value: name,
                label: label || name
            }))}
            onChange={handleValueChange}
            textFieldProps={{
                variant: 'filled',
                fieldStyles: fieldStyles || internals.filledFilterFieldStyles,
                InputLabelProps: {
                    shrink: true
                },
                InputProps: {
                    disableUnderline
                },
                inputProps: {
                    'aria-label': 'Role'
                },
                SelectProps: selectProps
            }}
        />;
    }

    return (
        <StyledFormControl>
            <SelectInputLabel id='role-label'>
                Role:
            </SelectInputLabel>
            <Select
                value={roleGroupFilter}
                onChange={handleChange}
                labelId='role-label'
                inputProps={{
                    'aria-labelledby': 'role-label'
                }}
                {...selectProps}
            >
                {roleOptions.map((option) => (

                    <MenuItem
                        key={option.id}
                        value={option.name}
                    >
                        <ListItemText
                            primary={option.label || option.name}
                            primaryTypographyProps={{ align: 'left' }}
                        />
                    </MenuItem>
                ))}
            </Select>
        </StyledFormControl>
    );
};

module.exports.propTypes = {
    roleGroupFilter: T.string.isRequired,
    setRoleGroupFilter: T.func.isRequired,
    availableRoleGroups: T.array,
    disableUnderline: T.bool,
    fieldStyles: T.array,
    onChange: T.func,
    selectVariant: T.string
};

internals.EmptySelectIcon = () => null;

internals.singleRoleSelectSx = {
    '& .MuiSelect-select': {
        paddingRight: '12px !important'
    }
};

internals.filledFilterFieldStyles = css`
    &.MuiFormControl-root {
        width: 150px;
        min-width: 150px;
        padding: 0 !important;
    }

    .MuiFilledInput-root {
        height: 48px;
        border-radius: 10px;
        background: rgba(18, 39, 79, 0.06);
        overflow: hidden;

        &:before,
        &:after,
        &:hover:not(.Mui-disabled):before {
            display: none;
        }

        &:hover,
        &.Mui-focused {
            background: rgba(18, 39, 79, 0.08);
        }
    }

    label.MuiInputLabel-root {
        max-width: calc(100% - 24px);
        margin-top: 0 !important;
        height: 16px !important;
        line-height: 16px !important;
        color: rgba(18, 39, 79, 0.56);
        font-size: 12px;
        transform: translate(12px, 5px) scale(1) !important;
        pointer-events: none;
    }

    .MuiInputLabel-shrink {
        transform: translate(12px, 5px) scale(1) !important;
    }

    .MuiSelect-select.MuiFilledInput-input {
        min-height: 20px;
        padding: 22px 32px 6px 12px !important;
        background: transparent;
        color: ${({ theme }) => theme.palette.text.primary};
        font-size: 16px;
        line-height: 20px;
    }

    .MuiSvgIcon-root {
        right: 8px;
        color: rgba(18, 39, 79, 0.56);
    }
`;

internals.StyledFormControl = Styled(FormControl)`
    min-width: 150px;
`;
